import { Children } from 'react';
import SectionHandler from './SectionHandler';
import { useSelector } from 'react-redux';
import { accordionHeadingStyling } from './formStyles';
import {
    Heading,
    AccordionButton,
    AccordionIcon,
    AccordionItem,
    AccordionPanel,
    Box,
    HStack,
    Icon,
    IconButton,
} from '@chakra-ui/react';
import { classNames } from '@/utils/classNames';
import { IoMdArrowUp } from 'react-icons/io';
import { IoMdArrowDown } from 'react-icons/io';

const AccordionItemHandler = ({
    children,
    index,
    icon,
    label,
    errors,
    touched,
    values,
    setValues,
    accordionAdornment,
    isDisabled,
    noOrder = true,
    onMoveUp,
    onMoveDown,
    platformIndex,
    platformsLength,
}) => {
    const childrenArray = Array.isArray(children)
        ? children
        : typeof children === 'function'
          ? [children({ errors, touched, values, setValues })]
          : [children];
    const childrenCount = Children.count(childrenArray);
    const { darkMode } = useSelector((state) => state.settings);
    return (
        <AccordionItem key={index} isDisabled={isDisabled}>
            {({ isExpanded }) => (
                <>
                    <HStack spacing={0} position="relative">
                        {!noOrder && (
                            <HStack spacing={0} mr={2}>
                                <IconButton
                                    aria-label="Move Up"
                                    variant="ghost"
                                    colorScheme="gray"
                                    icon={<IoMdArrowUp />}
                                    size="sm"
                                    _hover={{
                                        bg: 'transparent',
                                        color: darkMode ? 'white' : 'gray.700',
                                    }}
                                    onClick={onMoveUp}
                                    isDisabled={platformIndex === 0}
                                />
                                <IconButton
                                    aria-label="Move Down"
                                    variant="ghost"
                                    size="sm"
                                    colorScheme="gray"
                                    icon={<IoMdArrowDown />}
                                    _hover={{
                                        bg: 'transparent',
                                        color: darkMode ? 'white' : 'gray.700',
                                    }}
                                    onClick={onMoveDown}
                                    isDisabled={
                                        platformIndex === platformsLength - 1
                                    }
                                />
                            </HStack>
                        )}
                        <AccordionButton flex="1">
                            <Box as="span" flex="1" textAlign="left">
                                <HStack>
                                    {icon && <Icon as={icon} fontSize="25px" />}
                                    <Heading
                                        sx={accordionHeadingStyling}
                                        className={classNames(
                                            darkMode
                                                ? 'text-white'
                                                : 'text-black',
                                        )}>
                                        {label}
                                    </Heading>
                                </HStack>
                            </Box>
                            <Box as="span" flex="0" textAlign="right">
                                <AccordionIcon />
                            </Box>
                        </AccordionButton>
                        {accordionAdornment && (
                            <Box
                                position="absolute"
                                right="35px"
                                zIndex={2}
                                onClick={(e) => e.stopPropagation()}>
                                {accordionAdornment}
                            </Box>
                        )}
                    </HStack>
                    <AccordionPanel
                        pb={4}
                        mb={4}
                        sx={{
                            height: isExpanded ? 'auto' : 0,
                            overflow: 'hidden',
                        }}>
                        {Children.map(childrenArray, (child, index) => (
                            <SectionHandler
                                key={`section-handler-${index}`}
                                index={index}
                                child={child}
                                count={childrenCount}
                            />
                        ))}
                    </AccordionPanel>
                </>
            )}
        </AccordionItem>
    );
};

export default AccordionItemHandler;
